import { render, staticRenderFns } from "./AddCouriers.vue?vue&type=template&id=e6b4012c&scoped=true&"
import script from "./AddCouriers.vue?vue&type=script&async=true&lang=js&"
export * from "./AddCouriers.vue?vue&type=script&async=true&lang=js&"
import style0 from "./AddCouriers.vue?vue&type=style&index=0&id=e6b4012c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b4012c",
  null
  
)

export default component.exports